import React, { useState } from 'react';
import PropTypes from 'prop-types';
// components
import WidgetButtons from './WidgetButtons';
import CustomWidgetCard from './CustomWidgetCard';
// redux
import { useSelector } from '../../redux/store';
// hooks
import { useToggle } from '../../hooks';
// utils
import groupedTreatments from '../../utils/groupedTreatments';

const AttendedTableReportsWidget = ({ onWidgetClick, dateRangeProps, widgetToggle }) => {
    const { toggle: internalToggle, onOpen, onClose } = useToggle(true);
    const toggle = widgetToggle !== undefined ? widgetToggle : internalToggle;
    const { treatmentsList: { results } } = useSelector((state) => state.practiceTreatment);

    const [currentWidget, setCurrentWidget] = useState('');

    const treatments = groupedTreatments(results);

    const handleOpen = () => onOpen();

    const handleClose = () => onClose();

    const widgetArray = [
        { key: '1', icon: '', value: '0', text: 'Consultation follow ups' },
        { key: '2', icon: '', value: 'invisalign', text: 'Consultation attended for Invisalign', isTreatment: true },
        { key: '3', icon: '', value: 'bonding', text: 'Consultation attended for Bonding', isTreatment: true },
        { key: '4', icon: '', value: 'implants', text: 'Consultation attended for Implants', isTreatment: true },
        { key: '5', icon: '', value: 'whitening', text: 'Consultation attended for Whitening', isTreatment: true },
        { key: '6', icon: '', value: '6', text: 'Estimated value of consultations attended', isPrice: true },
    ];

    const normaliseValues = (value) => (Array.isArray(value) ? value : [value]).filter(Boolean);

    const handleWidgetClick = (value, key) => {
        setCurrentWidget(key);
        const values = normaliseValues(value).map((val) => val?.toString?.().toLowerCase?.()).filter(Boolean);
        if (!values.length || values.every((val) => val === '0')) {
            onWidgetClick([]);
            return;
        }
        onWidgetClick(treatments.filter((ele) => {
            const name = ele.name?.toLowerCase?.() || '';
            return values.some((val) => name.includes(val));
        }));
    };

    return (
        <>
            {dateRangeProps && <WidgetButtons
                toggle={toggle}
                dateRangeProps={dateRangeProps}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />}
            {toggle && (
                <CustomWidgetCard handleWidgetClick={handleWidgetClick} widgetArray={widgetArray} currentWidget={currentWidget} />
            )}
        </>
    );
};

export default AttendedTableReportsWidget;

AttendedTableReportsWidget.propTypes = {
    onWidgetClick: PropTypes.func,
    dateRangeProps: PropTypes.any,
    widgetToggle: PropTypes.bool,
};
